import { render, staticRenderFns } from "./ReviewsPerMonth.vue?vue&type=template&id=32ba3510"
import script from "./ReviewsPerMonth.vue?vue&type=script&lang=js"
export * from "./ReviewsPerMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports